import React from 'react';
import Projects from '../components/Projects';

const ProjectsPage: React.FC = () => {
  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <Projects />
    </div>
  );
};

export default ProjectsPage;
